import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFileEditComponent } from "./med-icon-file-edit.component";

@NgModule({
  declarations: [
    MedIconFileEditComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFileEditComponent,
  ],
})
export class MedIconFileEditModule { }
